import CardHeader from "components/CardHeader";
import { Email } from "models/Email";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Alert, Card, CardBody } from "reactstrap";
import * as api from "services/Api";
import { useOfficeTranslation } from "i18n/OfficeTranslation";

const AccountRecentEmailsCard: React.FC<{ accountId: string }> = ({ accountId }) => {
    const { intlLocale, t } = useOfficeTranslation();
    const [emails, setEmails] = useState<Email[]>([]);
    const [error, setError] = useState("");

    useEffect(() => {
        api.getEmailsByCustomer(accountId)
            .then(items => setEmails(
                items
                    .filter(email => email.direction === "out")
                    .sort((a, b) => b.date - a.date)
            ))
            .catch(() => setError(t("accounts.accountRecentEmailsCard.sentEmailsCouldNotBeLoaded")));
    }, [accountId, t]);

    return <Card>
        <CardBody>
            <CardHeader
                title={t("accounts.accountRecentEmailsCard.recentlySentEmails")}
                icon="mdi-email-send-outline"
                count={emails.length}
                actions={<Link
                    className="btn btn-sm btn-light"
                    to={`/conversations/compose?customer=${accountId}`}
                    aria-label={t("accounts.accountRecentEmailsCard.composeEmail")}
                >
                    <i className="mdi mdi-plus" />
                </Link>}
            />
            {error && <Alert color="danger" className="mt-3 mb-0">{error}</Alert>}
            {!error && emails.slice(0, 5).map(email =>
                <Link
                    to={`/conversation/${email.id}`}
                    className="d-block text-body border-bottom py-3"
                    key={email.id}
                >
                    <div className="d-flex justify-content-between gap-3">
                        <strong className="text-truncate">{email.subject || t("accounts.accountRecentEmailsCard.noSubject")}</strong>
                        <small className="text-muted flex-shrink-0">{email.GetDate().toLocaleDateString(intlLocale)}</small>
                    </div>
                    <small className="text-muted text-truncate d-block">{t("common.to")} {email.recipient || t("accounts.accountRecentEmailsCard.unknownRecipient")}</small>
                </Link>
            )}
            {!error && !emails.length && <p className="text-muted mt-3 mb-0">{t("accounts.accountRecentEmailsCard.noSentEmailsFoundForThisAccount")}</p>}
        </CardBody>
    </Card>;
};

export default AccountRecentEmailsCard;
